import { Routes } from '@angular/router';



// Pages
import { LandingPageComponent } from './components/pages/landing-page/landing-page.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { SoftwareComponent } from './components/pages/software/software.component';
import { MarkdownViewerComponent } from './components/utils/markdown-viewer/markdown-viewer.component';


export const routes: Routes = [
    { path: '', component: LandingPageComponent},
    { path: 'contact', component: ContactComponent},
    { path: 'software', component: SoftwareComponent},
    { path: 'markdown-viewer', component: MarkdownViewerComponent },
];

/*
{ path: 'cookiePolicy', component: AudidatCookiePolicyComponent},
{ path: 'dataProtectionPolicy', component: AudidatDataProtectionPolicyComponent},
{ path: 'privacyPolicy', component: AudidatPrivacyPolicyComponent},
{ path: 'whoWeAre', component: WhoWeAreComponent},
{ path: 'qualityPolicy', component: InnovaQualityPolicyComponent},
{ path: 'pdf-viewer', component: PdfViewerComponent },
*/